import { Link } from "@mui/material";
import { useTranslation } from "react-i18next";

export function mapSearchUrl(query) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

const MapAddressLink = ({ city, address, sx }) => {
  const { t } = useTranslation("common");
  const text = String(address || "").trim();
  if (!text) return null;
  const place = [city, text].filter(Boolean).join(", ");
  return (
    <Link
      href={mapSearchUrl(place)}
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      title={t("booking.viewOnMap")}
      color="inherit"
      onClick={(event) => event.stopPropagation()}
      sx={{ fontSize: "inherit", ...sx }}
    >
      {text}
    </Link>
  );
};

export default MapAddressLink;
